import * as tf from "@tensorflow/tfjs";
import { MOVES } from "@/constants";

export default class CPU {
  constructor(converterClass) {
    this.converter = new converterClass();
  }

  async load() {
    this.model = Object.freeze(await tf.loadLayersModel("model/model.json"));
  }

  move(board, fieldValue) {
    let prediction = this.model
      .predict(this.converter.convert(board))
      .arraySync()
      .flat();
    let moveId = null;
    let index = 0;
    do {
      const bestPrediction = Math.max(...prediction);
      index = prediction.indexOf(bestPrediction);
      moveId = Object.keys(MOVES)[index];
      prediction[index] = -1;
    } while (fieldValue & MOVES[moveId]);
    return moveId;
  }

  isReady() {
    return !!this.model;
  }
}
